import {
  createRouter,
  createWebHashHistory,
  createWebHistory,
  RouteRecordRaw,
} from "vue-router";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    redirect: "/login",
  },
  {
    path: "/lay",
    component: () => import("../base-ui/lay/src/lay.vue"),
  },
  {
    path: "/login",
    name: "login",
    component: () => import("../views/login/login.vue"),
  },
  {
    path: "/main",
    name: "main",
    redirect: "/main/goods",
    component: () => import("../views/main/main.vue"),
    children: [
      {
        path: "goods",
        component: () => import("../views/main/goods/goods.vue"),
      },
      {
        path: "cloth",
        component: () => import("../views/main/cloth/cloth.vue"),
      },
      {
        path: "delivery",
        component: () => import("../views/main/delivery/delivery.vue"),
      },
      {
        path: "box",
        component: () => import("../views/main/box/box.vue"),
      },
      {
        path: "log",
        component: () => import("../views/main/log/log.vue"),
      },
      {
        path: "label",
        component: () => import("../views/main/label/label.vue"),
      },
    ],
  },
  {
    path: "/:pathMatch(.*)*",
    name: "notFound",
    component: () => import("@/views/not-found/not-found.vue"),
  },
];

const router = createRouter({
  // history: createWebHashHistory(),
  history: createWebHistory(),
  routes,
});

router.beforeEach((to) => {
  // console.log("路由", to);
  const token = localStorage.getItem("token");

  // 1. 没有 token → 强制到登录页
  if (!token) {
    if (to.path !== "/login") {
      return "/login"; // 使用 return 正常跳转
    }
    return;
  }

  // 2. 有 token → 不允许去 login，自动进入 main/goods
  if (to.path === "/" || to.path === "/login") {
    return "/main/goods";
  }

  // 3. 有 token 访问 /main → 自动跳入默认子路由
  if (to.path === "/main") {
    return "/main/goods";
  }

  return; // 其他情况放行
});

export default router;
